import Filter from "./Filter";

const Filters = ({ filtersList, setFilters }) => {

	const renderFilters = () => {

		if (!Object.keys(filtersList).length > 0) return null;

		return Object.keys(filtersList).map((filter, index) => {
			return <Filter filters={filtersList[filter]} index={index} />;
		});
	};

	const handleSubmit = (event) => {

		event.preventDefault();

		setFilters({
			topic: event.target.elements.resource_topic.value ? event.target.elements.resource_topic.value : "",
			type: event.target.elements.resource_type.value ? event.target.elements.resource_type.value : "",
			level: event.target.elements.resource_level.value ? event.target.elements.resource_level.value : "",
		});
	}

	return (
		<div className="index-page__filters">
			<form action="sumbit" onSubmit={handleSubmit}>
				{renderFilters()}
				<div className="index-page__filters__buttons">
					<button>Apply Filters</button>
					<span onClick={() => setFilters({
						resource_topic: "",
						resource_type: "",
						resource_level: ""
					})}>
						Clear Filters
					</span>
				</div>
			</form>
		</div>
	);
};

export default Filters;
